<syslink-grid
  #grid
  [gridName]="storageKey"
  [canView]="canView"
  [canSearch]="canSearch"
  [canRefresh]="canRefresh"
  [canAdd]="canAdd"
  [canSort]="canSort"
  [canFilter]="canFilter"
  [canExport]="canExport"
  [canDblClck]="canDblClck"
  [canDelete]="canDelete"
  [canUpdate]="canUpdate"
  [service]="NumberPlatesService"
  [columns]="columns"
  [storageKey]="storageKey"
  [expand]="expand"
  [select]="select"
  (beforeAdd)="beforeAdd.emit($event)"
  [filter]="filter"
></syslink-grid>